module.exports = __webpack_public_path__ + "img/music_008.f178dcc2.png";